<template>
    <div>
        <card-header title="Edit Conference" icon="fa-pencil"/>

        <card-body>
            <rmc-conference-form :conference="conference"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click=""><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Conference?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!conference.title || !conference.code || !conference.start || !conference.end"
                    ><i class="fas fa-check mr-2"></i>Save Conference
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcConferenceForm from "@/cards/RMC/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import moment from "moment";

    export default {
        components: {RmcConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                conference: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadConference: function() {
                this.$emit('loading', true);
                http.get('rmc/conferences/' + this.props.confId, {force: true}).then(response => {
                    this.conference = response.data;
                    this.conference.start = (response.data.start_at) ? moment(response.data.start_at).toDate() : null;
                    this.conference.end = (response.data.end_at) ? moment(response.data.end_at).toDate() : null;
                    this.conference.close = (response.data.close_at) ? moment(response.data.close_at).toDate() : null;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                http.put('rmc/conferences/' + this.props.confId, {
                    title: this.conference.title,
                    code: this.conference.code,
                    location: this.conference.location,
                    start: this.conference.start,
                    end: this.conference.end,
                    close: this.conference.close,
                    logo: this.conference.logo,
                    description: this.conference.description,
                    information: this.conference.information,
                    no_phone: this.conference.no_phone,
                    no_address: this.conference.no_address,
                    wa_edu: this.conference.wa_edu,
                    allow_cc: this.conference.allow_cc,
                    allow_po: this.conference.allow_po,
                    po_mail_to: this.conference.po_mail_to,
                    po_attn_to: this.conference.po_attn_to,
                    po_address_1: this.conference.po_address_1,
                    po_address_2: this.conference.po_address_2,
                    po_city: this.conference.po_city,
                    po_state: this.conference.po_state,
                    po_zip: this.conference.po_zip,
                    po_email: this.conference.po_email,
                    po_instructions: this.conference.po_instructions,
                    registration_cap: this.conference.registration_cap
                }, {force: true}).then(response => {
                    this.$reloadCard('rmc-conferences');
                    this.$reloadCard('rmc-conference', {confId: this.props.confId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the conference.');
                    this.$emit('loading', false);
                });
            }
        },
        watch: {
            'props.confId': function() {
                this.dirty = null;
                this.loadConference();
            },
            'conference': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this conference? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadConference();
        }
    };
</script>
